export default __webpack_public_path__ + "static/media/cloudformation.b2a57f52.svg";